export const ENABLE_PLAYBACK_SPEED_CONTROL =
  'web.playback.speed.control.enabled';
export const IHEARTRADIO_ALBUM_ART_ENABLED = 'iHeartRadio.albumArt.enabled';
